module.exports = __webpack_public_path__ + "static/media/MuseoSansRegular.b3e4dd55.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansRegular/MuseoSansRegular.woff
// module id = 636
// module chunks = 0